import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class ETagStorageService {
  private etagMap = new Map<string, string>();

  public set(resourceKey: string, eTag: string): void {
    this.etagMap.set(resourceKey.toLowerCase(), eTag);
  }

  public get(resourceKey: string): string {
    const lowerCaseKey = resourceKey.toLowerCase();

    if (!this.etagMap.has(lowerCaseKey)) {
      throw new Error(`ETag for key - ${lowerCaseKey} not found.`);
    }

    return this.etagMap.get(lowerCaseKey);
  }

  public remove(resourceKey: string): void {
    this.etagMap.delete(resourceKey.toLowerCase());
  }

  public clearAll(): void {
    this.etagMap.clear();
  }
}
